module.exports = __webpack_public_path__ + "img/数据中心.6ae84654.svg";